import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';

@Injectable({
  providedIn: 'root'
})
export class MoistureProfileAdminService {
  constructor(private $shttp: SuperHttpClientProvider) {}

  listProfiles() {
    return this.$shttp.default.get('/admin/moisture-profile');
  }

  getProfile(id: number) {
    return this.$shttp.default.get(`/admin/moisture-profile/${id}`);
  }

  createProfile(dto: { name: string }) {
    return this.$shttp.default.post('/admin/moisture-profile', dto);
  }

  updateProfile(id: number, dto: { name: string }) {
    return this.$shttp.default.put(`/admin/moisture-profile/${id}`, dto);
  }

  deleteProfile(id: number) {
    return this.$shttp.default.delete(`/admin/moisture-profile/${id}`);
  }

  listSeasons(profileId: number, idCliente?: number) {
    const url = idCliente
      ? `/admin/moisture-profile/${profileId}/seasons?idCliente=${idCliente}`
      : `/admin/moisture-profile/${profileId}/seasons`;
    return this.$shttp.default.get(url);
  }

  createSeason(profileId: number, dto: any, idCliente?: number) {
    const url = idCliente
      ? `/admin/moisture-profile/${profileId}/seasons?idCliente=${idCliente}`
      : `/admin/moisture-profile/${profileId}/seasons`;
    return this.$shttp.default.post(url, dto);
  }

  updateSeason(seasonId: number, dto: any, idCliente?: number) {
    const payload = {
      ...dto,
      idMoistureProfileSeason: dto?.idMoistureProfileSeason ?? seasonId
    };
    const url = idCliente
      ? `/admin/moisture-profile-season/${seasonId}?idCliente=${idCliente}`
      : `/admin/moisture-profile-season/${seasonId}`;
    return this.$shttp.default.put(url, payload);
  }

  deleteSeason(seasonId: number, idCliente?: number) {
    const url = idCliente
      ? `/admin/moisture-profile-season/${seasonId}?idCliente=${idCliente}`
      : `/admin/moisture-profile-season/${seasonId}`;
    return this.$shttp.default.delete(url);
  }
}
